const sessionIcons = {
    'Sitting': require('./session-icons/Sitting.png'),
    'Lying down': require('./session-icons/Lying-down.png'),
    'Cycling': require('./session-icons/Cycling.png'),
    'default-session': require('./session-icons/default-session.png'),
    'On the go': require('./session-icons/On-the-go.png'),
    'Running': require('./session-icons/Running.png'),
    'Swimming': require('./session-icons/Swimming.png'),
    'Walking': require('./session-icons/Walking.png'),
    'Workout': require('./session-icons/Workout.png'),
};

export default sessionIcons;